var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95313 11.0195V15.9895C4.95313 17.8095 4.95312 17.8095 6.67312 18.9695L11.4031 21.6995C12.1131 22.1095 13.2731 22.1095 13.9831 21.6995L18.7131 18.9695C20.4331 17.8095 20.4331 17.8095 20.4331 15.9895V11.0195C20.4331 9.19945 20.4331 9.19945 18.7131 8.03945L13.9831 5.30945C13.2731 4.89945 12.1131 4.89945 11.4031 5.30945L6.67312 8.03945C4.95312 9.19945 4.95313 9.19945 4.95313 11.0195Z",
    stroke: "#37588A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1934 7.63V5C18.1934 3 17.1934 2 15.1934 2H10.1934C8.19336 2 7.19336 3 7.19336 5V7.56",
    stroke: "#37588A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3231 10.9909L13.8931 11.8809C13.9831 12.0209 14.1831 12.1609 14.3331 12.2009L15.3531 12.4609C15.9831 12.6209 16.1531 13.1609 15.7431 13.6609L15.0731 14.4709C14.9731 14.6009 14.8931 14.8309 14.9031 14.9909L14.9631 16.0409C15.0031 16.6909 14.5431 17.0209 13.9431 16.7809L12.9631 16.3909C12.8131 16.3309 12.5631 16.3309 12.4131 16.3909L11.4331 16.7809C10.8331 17.0209 10.3731 16.6809 10.4131 16.0409L10.4731 14.9909C10.4831 14.8309 10.4031 14.5909 10.3031 14.4709L9.63314 13.6609C9.22314 13.1609 9.39314 12.6209 10.0231 12.4609L11.0431 12.2009C11.2031 12.1609 11.4031 12.0109 11.4831 11.8809L12.0531 10.9909C12.4131 10.4509 12.9731 10.4509 13.3231 10.9909Z",
    stroke: "#37588A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.a321d5f5e278a5c180035624918bfdee.svg";
export { ForwardRef as ReactComponent };